import React, { useState, useEffect } from "react";
import styles from "./galeria_robertinhotattooarts.module.scss";
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { Link } from "react-router-dom";
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaTimes, FaArrowUp } from "react-icons/fa";
import FacebookIcon from "../../icons/facebookIcon.tsx";
import Instagram1 from './src/instagram1.png';
import Instagram2 from './src/instagram2.png';

// Import das imagens
import Gal1 from './src/galeria/1.jpeg';
import Gal2 from './src/galeria/2.jpeg';
import Gal3 from './src/galeria/3.jpeg';
import Gal4 from './src/galeria/4.jpeg';
import Gal5 from './src/galeria/5.jpeg';
import Gal6 from './src/galeria/6.jpeg';
import Gal7 from './src/galeria/7.jpeg';
import Gal8 from './src/galeria/8.jpeg';
import Gal9 from './src/galeria/9.jpeg';
import Gal10 from './src/galeria/10.jpeg';
import Gal12 from './src/galeria/12.jpeg';
import Gal13 from './src/galeria/13.jpeg';
import Gal14 from './src/galeria/14.jpeg';
import Gal15 from './src/galeria/15.jpeg';
import Gal16 from './src/galeria/16.jpeg';
import Gal17 from './src/galeria/17.jpeg';
import Gal18 from './src/galeria/18.jpeg';
import Gal19 from './src/galeria/19.jpeg';
import Gal20 from './src/galeria/20.jpeg';
import Gal21 from './src/galeria/21.jpeg';
import Gal22 from './src/galeria/22.jpeg';
import Gal23 from './src/galeria/23.jpeg';
import Gal24 from './src/galeria/24.jpeg';
import Gal25 from './src/galeria/25.jpeg';
import Gal26 from './src/galeria/26.jpeg';
import Gal27 from './src/galeria/27.jpeg';
import Gal28 from './src/galeria/28.jpeg';
import Gal29 from './src/galeria/29.jpeg';
import Gal30 from './src/galeria/30.jpeg';
import Gal31 from './src/galeria/31.jpeg';
import Gal32 from './src/galeria/32.jpeg';
import Gal33 from './src/galeria/33.jpeg';
import Gal34 from './src/galeria/34.jpeg';
import Gal35 from './src/galeria/35.jpeg';
import Gal36 from './src/galeria/36.jpeg';
import Gal37 from './src/galeria/37.jpeg';
import Gal38 from './src/galeria/38.jpeg';
import Gal39 from './src/galeria/39.jpeg';
import Gal40 from './src/galeria/40.jpeg';
import Gal41 from './src/galeria/41.jpeg';
import Gal42 from './src/galeria/42.jpeg';
import Gal43 from './src/galeria/43.jpeg';
import Gal44 from './src/galeria/44.jpeg';
import Gal45 from './src/galeria/45.jpeg';
import Gal46 from './src/galeria/46.jpeg';
import Gal47 from './src/galeria/47.jpeg';
import Gal48 from './src/galeria/48.jpeg';
import Gal49 from './src/galeria/49.jpeg';
import Gal50 from './src/galeria/50.jpeg';
import Gal51 from './src/galeria/51.jpeg';
import Gal52 from './src/galeria/52.jpeg';

const Galeria_robertinhotattooarts: React.FC = () => {
    const [showInstagrams, setShowInstagrams] = useState(false);

    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showScrollTop, setShowScrollTop] = useState(false);

    const imagens = [
        Gal1,
        Gal2,
        Gal3,
        Gal4,
        Gal5,
        Gal6,
        Gal7,
        Gal8,
        Gal9,
        Gal10,
        Gal12,
        Gal13,
        Gal14,
        Gal15,
        Gal16,
        Gal17,
        Gal18,
        Gal19,
        Gal20,
        Gal21,
        Gal22,
        Gal23,
        Gal24,
        Gal25,
        Gal26,
        Gal27,
        Gal28,
        Gal29,
        Gal30,
        Gal31,
        Gal32,
        Gal33,
        Gal34,
        Gal35,
        Gal36,
        Gal37,
        Gal38,
        Gal39,
        Gal40,
        Gal41,
        Gal42,
        Gal43,
        Gal44,
        Gal45,
        Gal46,
        Gal47,
        Gal48,
        Gal49,
        Gal50,
        Gal51,
        Gal52
    ];

    const openLightbox = (index: number) => {
        setCurrentIndex(index);
        setLightboxOpen(true);
    };

    const closeLightbox = () => setLightboxOpen(false);
    const prevImage = () =>
        setCurrentIndex((prev) => (prev === 0 ? imagens.length - 1 : prev - 1));
    const nextImage = () =>
        setCurrentIndex((prev) => (prev === imagens.length - 1 ? 0 : prev + 1));

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 300);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div className={styles.galeria_robertinhotattooarts}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/robertinhotattooarts" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Galeria</h1>
            </div>

            {/* CONTEÚDO - Galeria */}
            <div className={styles.content}>
                <div className={styles.galleryGrid}>
                    {imagens.map((img, index) => (
                        <div
                            key={index}
                            className={styles.imageContainer}
                            onClick={() => openLightbox(index)}
                        >
                            <img src={img} alt={`Galeria ${index + 1}`} />
                        </div>
                    ))}
                </div>
            </div>

            {/* Lightbox */}
            {lightboxOpen && (
                <div className={styles.lightbox}>
                    <button className={styles.closeBtn} onClick={closeLightbox}>
                        <FaTimes />
                    </button>
                    <button className={styles.prevBtn} onClick={prevImage}>
                        <FaChevronLeft />
                    </button>
                    <img
                        src={imagens[currentIndex]}
                        alt={`Galeria ${currentIndex + 1}`}
                        className={styles.lightboxImage}
                    />
                    <button className={styles.nextBtn} onClick={nextImage}>
                        <FaChevronRight />
                    </button>
                </div>
            )}

            {/* BOTÃO FLUTUANTE */}
            {showScrollTop && (
                <button className={styles.scrollTopButton} onClick={scrollToTop}>
                    <FaArrowUp />
                </button>
            )}

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    <a href="https://wa.me/5518997951461?text=Olá, vim pelo link na bio e gostaria de mais informações..." target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><WhatsappIcon height="30" color="#ffffff" /></div>
                            <span>WhatsApp</span>
                        </div>
                    </a>
                    <a href="https://maps.app.goo.gl/gsz8eDGiUeehrH1k7" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><MapsIcon height="30" color="#ffffff" /></div>
                            <span>Localização</span>
                        </div>
                    </a>
                    <a href="https://www.facebook.com/share/1QhqZopD9j/?mibextid=wwXIfr" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><FacebookIcon height="30" color="#ffffff" /></div>
                            <span>Facebook</span>
                        </div>
                    </a>
                    <div onClick={() => setShowInstagrams(true)}>
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><InstagramIcon height="26" color="#ffffff" /></div>
                            <span>Instagram</span>
                        </div>
                    </div>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
            {showInstagrams && (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setShowInstagrams(false)}
                >
                    <div
                        className={styles.modalContent}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className={styles.closeButton}
                            onClick={() => setShowInstagrams(false)}
                        >
                            ✕
                        </button>
                        <h2>Instagram</h2>
                        <div className={styles.modalGrid}>
                            <div className={styles.modalCard}>
                                <img src={Instagram1} />
                                <p>@robertinho_q.o.e.s</p>
                                <a
                                    href="https://www.instagram.com/robertinho_q.o.e.s?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button className={styles.mapButton}>
                                        <InstagramIcon height="18" color="#fff" />
                                        <span>Acessar</span>
                                    </button>
                                </a>
                            </div>
                            <div className={styles.modalCard}>
                                <img src={Instagram2} />
                                <p>@robertinho.tattoo.arts</p>
                                <a
                                    href="https://www.instagram.com/robertinho.tattoo.arts?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button className={styles.mapButton}>
                                        <InstagramIcon height="18" color="#fff" />
                                        <span>Acessar</span>
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Galeria_robertinhotattooarts;
